import type { RouteRecordRaw } from 'vue-router';

/**
 * «Навчаються» — типовий вигляд списку: лише ті, в кого є поточне навчання.
 */
export const studentsRoute: RouteRecordRaw = {
  path: '/students',
  name: 'Students',
  component: () => import('./pages/StudentsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:students:list'),
  },
};

/**
 * «Усі» — той самий список разом із випускниками й відрахованими. Та сама
 * сторінка під другою адресою: роутер лишає її змонтованою, і пошук із чипами
 * переходять разом із нею.
 *
 * `/students/all` картку не відкриває: статичний сегмент vue-router ранжує
 * вище за `/students/:id`, хоч би в якому порядку їх зареєстровано.
 */
export const studentsAllRoute: RouteRecordRaw = {
  path: '/students/all',
  name: 'StudentsAll',
  component: () => import('./pages/StudentsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:students:list'),
  },
};

export const studentDetailRoute: RouteRecordRaw = {
  path: '/students/:id',
  name: 'StudentDetail',
  component: () => import('./pages/StudentPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:students:get'),
  },
};
